<template>
  <div class="search-component-wrap">
    <el-tabs 
      v-model="activeName" 
      class="search-wrap"
    >
      <el-tab-pane 
        label="编年检索"
        name="first" 
      >
        <search-input
          :searhTypeOptions="getFilterOptions()"
          :defaultSearchType="searchType"
          @search="data => search(data, chronology, '/chronologySearch')"
        />
      </el-tab-pane>
      <el-tab-pane
        label="全库检索" 
        name="second"
      >
        <search-input
          :searhTypeOptions="searhTypeOptions"
          :defaultSearchType="searchType"
          @dimensionChange="dimensionChange"
          @search="data => search(data, history, '/fullLibSearch')"
        />
      </el-tab-pane>
    </el-tabs>
    <div class="router-wrap">
      <el-button 
        @click="toLib('http://www.reformdata.org/orh/')"
      >口述改革</el-button>
      <el-button 
        class="margin-left16" 
        @click="toLib('http://www.reformdata.org/rhn/')"
      >见证实物</el-button>
    </div>
  </div>
  
</template>

<script>
import {mapState, mapMutations} from 'vuex'

// component
import searchInput from './searchInput'

export default {
  components: {searchInput},
  props: {
    // 是否在编年检索页面当前页搜索，如果是，则不跳转
    chronology: {
      type: Boolean,
      default: false
    },
    // 是否在全库搜索当前页搜索
    history: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const page = this.$route.name
    let searchType = 'titleAndMainContent'
    if (this.$route.query.content) {
      searchType = this.$route.query.type
    }

    return {
      activeName: page === 'fullLibSearch' ? 'second' : 'first',
      searchType: searchType,
      searhTypeOptions: [
        ...window.dictionaryConfig.searhTypeOptions,
        {
          label: '文章来源',
          value: 'sourceNames'
        }
      ]
    }
  },
  methods: {
    getFilterOptions () {
      return this.searhTypeOptions.filter(item => {
        return item.label !== '标签'
      })
    },

    dimensionChange (val) {
      this.$emit('dimensionChange', val)
    },

    // @search data:参数 stop:是否阻止跳转， path：跳转路径
    search (data, stop, path) {
      if (stop) {
        this.$emit('wordSearch', data)
        return false
      }

      this.$router.push({
        path: path,
        query: {
          type: data.searchType,
          content: data.searchText
        }
      })
    },

    toLib (href) {
      window.open(href)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/searchComponent/searchComponent.vue